(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/loading-state/assets/javascripts/loading-state-middleware.js') >= 0) return;  svs.modules.push('/components/tipsen/loading-state/assets/javascripts/loading-state-middleware.js');
"use strict";

const startLoadingAction = svs.components.tipsen.loadingState.actions.startLoadingAction;
const _RTK = RTK,
  isPending = _RTK.isPending,
  isRejected = _RTK.isRejected,
  isFulfilled = _RTK.isFulfilled;
const loadingStateMiddleware = _ref => {
  let dispatch = _ref.dispatch;
  const timers = {};
  return next => action => {
    var _action$meta$arg;
    if (isPending(action) && (_action$meta$arg = action.meta.arg) !== null && _action$meta$arg !== void 0 && _action$meta$arg.loadingMeta) {
      const _action$meta$arg$load = action.meta.arg.loadingMeta,
        key = _action$meta$arg$load.key,
        pause = _action$meta$arg$load.pause;
      if (pause > 0) {
        timers[action.meta.requestId] = setTimeout(() => {
          dispatch(startLoadingAction({
            key,
            requestId: action.meta.requestId
          }));
        }, pause);
      }
    } else if (isRejected(action) || isFulfilled(action)) {
      if (timers[action.meta.requestId]) {
        clearTimeout(timers[action.meta.requestId]);
      }
    }
    next(action);
  };
};
setGlobal('svs.components.tipsen.loadingState.loadingStateMiddleware', loadingStateMiddleware);

 })(window);